import { SuppliersApi, useAPIQueryAndQueryKey } from "melco-shared-logic";
import { PublishState } from "../../helper/publishedState";

export const useGetSupplierProduct = (
  supplierProductId: string,
  publishState: PublishState
) => {
  // const token = useUserToken();
  // const impersonationForId = useImpersonationForId();

  //const api = new ControlCenterApi(defaultApiConfig({ token, impersonationForId }));

  // const authenticatedApiConfig = useAuthenticatedAPIConfig();

  //const api = new ControlCenterApi(authenticatedApiConfig());

  return useAPIQueryAndQueryKey(
    SuppliersApi,
    ["supplierProduct", supplierProductId, publishState],
    async (api) =>
      api.supplierProductsGet({ id: supplierProductId, publishState })
  );
};
